/**
 * @description Gestion des fontions communes aux pages du site
 */

(() => {
  // FONCTIONS
  // Savoir quand la page est chargée
  const loaded = () => {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.classList.add('loaded');
      bsBreakpoints.init();
    });
  };

  const deleteEmpty = html => {
    document.querySelectorAll(html).forEach(el => {
      const content = el.innerText;
      if (content === null || content === undefined || content === '') {
        el.remove();
      }
    });
  };

  // GO 🚀
  const init = () => {
    loaded();
    deleteEmpty('p');
    deleteEmpty('li');
  };

  init();
})();
